export default __webpack_public_path__ + "static/media/splash-robot.8dec5744.png";